"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[231],{

/***/ 81572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ fetchMyBundlePasses; },
/* harmony export */   "OO": function() { return /* binding */ fetchPaymentItemDetail; },
/* harmony export */   "U4": function() { return /* binding */ fetchPromotion; },
/* harmony export */   "X7": function() { return /* binding */ fetchAchievmentPage; },
/* harmony export */   "eB": function() { return /* binding */ postAchievement; },
/* harmony export */   "hZ": function() { return /* binding */ fetchPassItemDetail; },
/* harmony export */   "mK": function() { return /* binding */ verifyPaymentItem; },
/* harmony export */   "nw": function() { return /* binding */ fetchMySubscriptions; },
/* harmony export */   "q0": function() { return /* binding */ fetchStoreBundlePassItems; },
/* harmony export */   "rH": function() { return /* binding */ fetchPaymentItems; },
/* harmony export */   "yL": function() { return /* binding */ postPromotion; },
/* harmony export */   "zJ": function() { return /* binding */ fetchRecommendPaymentItems; }
/* harmony export */ });
/* unused harmony exports fetchStoreBundlePassItemDetail, fetchSubscriptionDetail */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var fetchRecommendPaymentItems = function() {
    var _ref = _asyncToGenerator(function(vendor) {
        var data, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/goods-items/recommend".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            vendor: vendor
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchRecommendPaymentItems(vendor) {
        return _ref.apply(this, arguments);
    };
}();
var verifyPaymentItem = function() {
    var _ref = _asyncToGenerator(function(paymentId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/store/goods-items/".concat(paymentId, "/check-purchasable/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function verifyPaymentItem(paymentId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPaymentItems = function() {
    var _ref = _asyncToGenerator(function(query) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/goods-items/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpread({}, query))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPaymentItems(query) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPaymentItemDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/goods-items/".concat(paymentItemId))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPaymentItemDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPromotion = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/promotions/".concat(id))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPromotion(id) {
        return _ref.apply(this, arguments);
    };
}();
var postPromotion = function() {
    var _ref = _asyncToGenerator(function() {
        var promotionId, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    promotionId = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/store/promotions/".concat(promotionId, "/histories/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postPromotion() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPassItemDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/bundle-passes/".concat(paymentItemId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPassItemDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyBundlePasses = function() {
    var _ref = _asyncToGenerator(function(isInProgress, isExpired, bundlePassType) {
        var data, err;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/my-bundle-passes/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpread({}, isInProgress && {
                            isInProgress: isInProgress
                        }, isExpired && {
                            isExpired: isExpired
                        }, bundlePassType && {
                            bundlePassType: bundlePassType
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    err = _state.sent();
                    console.log(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchMyBundlePasses(isInProgress, isExpired, bundlePassType) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoreBundlePassItems = function() {
    var _ref = _asyncToGenerator(function(param) {
        var bundlePassType, vendor, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    bundlePassType = param.bundlePassType, vendor = param.vendor;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/bundle-pass-payment-items/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpread({}, bundlePassType && {
                            bundlePassType: bundlePassType
                        }, vendor && {
                            vendor: vendor
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoreBundlePassItems(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoreBundlePassItemDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/bundle-pass-payment-items/".concat(paymentItemId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoreBundlePassItemDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSubscriptionDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/subscriptions/".concat(paymentItemId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchSubscriptionDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMySubscriptions = function() {
    var _ref = _asyncToGenerator(function() {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, perPage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/my-subscriptions/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMySubscriptions() {
        return _ref.apply(this, arguments);
    };
}();
var fetchAchievmentPage = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/achievements_page/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchAchievmentPage() {
        return _ref.apply(this, arguments);
    };
}();
var postAchievement = function() {
    var _ref = _asyncToGenerator(function(param) {
        var achievementId, itemId, requirement, key, requirementKey, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    achievementId = param.achievementId, itemId = param.itemId, requirement = param.requirement, key = param.key;
                    requirementKey = key ? key : "unit_id";
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/achievements/".concat(achievementId, "/items/").concat(itemId, "/purchase/"), {
                            requirement_completion_extra: _defineProperty({}, requirementKey, requirement)
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postAchievement(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 38662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ characters_CharacterCardList; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/usePlayer.ts
var usePlayer = __webpack_require__(75046);
// EXTERNAL MODULE: ./hooks/query/useUserQuery.ts
var useUserQuery = __webpack_require__(75319);
// EXTERNAL MODULE: ./hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(41785);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./hooks/useScrollPosition.ts
var useScrollPosition = __webpack_require__(80786);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/index.js + 4 modules
var components_form = __webpack_require__(61527);
// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./components/modal/CharacterDeleteModal.tsx
var CharacterDeleteModal = __webpack_require__(60280);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/query.ts
var query = __webpack_require__(96261);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/common/Card.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-height: 216px;\n  flex-direction: column;\n  border-radius: ",
        "px;\n  overflow: hidden;\n  background-color: ",
        ";\n  box-shadow: 3px -2px 20px 10px #0000000d;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Radius.small */.wU.small, theme.var.white);
};
var Card = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: containerCSS,
        children: children
    });
};
/* harmony default export */ var common_Card = (Card);

// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
;// CONCATENATED MODULE: ./public/icons/ic_plus_bold.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcPlusBold = function SvgIcPlusBold(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M14.531 3.75a1.406 1.406 0 0 1 1.406 1.406v7.969h7.97a1.406 1.406 0 0 1 0 2.813h-7.97v7.968a1.406 1.406 0 0 1-2.812 0v-7.968H5.156a1.406 1.406 0 0 1 0-2.813h7.969V5.156a1.406 1.406 0 0 1 1.406-1.406"
  })));
};
/* harmony default export */ var ic_plus_bold = (SvgIcPlusBold);
;// CONCATENATED MODULE: ./components/characters/CharacterAddCard.tsx
function CharacterAddCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CharacterAddCard_templateObject() {
    var data = CharacterAddCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 166px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        "px;\n\n  ",
        ";\n  font-size: 12px;\n  line-height: 16.2px;\n  text-align: center;\n"
    ]);
    CharacterAddCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = CharacterAddCard_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    background: ",
        ";\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CharacterAddCard_containerCSS = (0,emotion_react_browser_esm.css)(CharacterAddCard_templateObject(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Typography.h6 */.ZT.h6);
var plusCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), isCheming ? "".concat(theme.colors.main500) : "linear-gradient(90deg, #04c8d0 0%, #1590d5 95.45%)", dist_esm/* Radius.round */.wU.round);
    };
};
var CharacterAddCard = function(param) {
    var handleOnClick = param.handleOnClick, isCheming = param.isCheming;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(common_Card, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: CharacterAddCard_containerCSS,
            onClick: handleOnClick,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    css: plusCSS(isCheming),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                        icon: ic_plus_bold
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                    children: [
                        "내 캐릭터를",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                        "만들어 보세요 \uD83D\uDE0B"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var characters_CharacterAddCard = (CharacterAddCard);

// EXTERNAL MODULE: ./utils/chat.ts
var chat = __webpack_require__(42127);
;// CONCATENATED MODULE: ./components/characters/PlayCountCard.tsx
function PlayCountCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PlayCountCard_templateObject() {
    var data = PlayCountCard_taggedTemplateLiteral([
        "\n    ",
        ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 19px 0;\n    margin: ",
        ";\n    border-radius: ",
        "px;\n    font-weight: 400;\n\n    .count {\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 600;\n      margin-top: 10px;\n    }\n  "
    ]);
    PlayCountCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PlayCountCard_containerCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(PlayCountCard_templateObject(), dist_esm/* Typography.body12 */.ZT.body12, isCheming ? theme.colors.main50 : theme.var.gray900, isCheming ? theme.var.black : theme.var.white, isCheming ? "0px 0px 20px" : "16px 0", dist_esm/* Radius.medium */.wU.medium);
    };
};
var PlayCountCard = function(param) {
    var isMyPage = param.isMyPage, user = param.user, player = param.player;
    var ref, ref1;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var text = isCheming ? "이만큼 대화했어요 \uD83D\uDCAC" : "이만큼 플레이 했어요 \uD83D\uDC40";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: PlayCountCard_containerCSS(isCheming),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                children: [
                    isMyPage ? "유저들이 내 캐릭터를 " : "".concat(user === null || user === void 0 ? void 0 : user.nickname, "님의 캐릭터를 유저들이 "),
                    text
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: "count",
                children: (0,chat/* formatNumberMillion */.OQ)((player === null || player === void 0 ? void 0 : (ref = player.stat) === null || ref === void 0 ? void 0 : ref.my_character_message_count) || 0) === "0" ? "-" : (0,chat/* formatNumberMillion */.OQ)((player === null || player === void 0 ? void 0 : (ref1 = player.stat) === null || ref1 === void 0 ? void 0 : ref1.my_character_message_count) || 0)
            })
        ]
    });
};
/* harmony default export */ var characters_PlayCountCard = (PlayCountCard);

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/common/ActionSheet.tsx
var ActionSheet = __webpack_require__(83898);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
;// CONCATENATED MODULE: ./public/icons/ic_lock_small.svg
var _g, _defs;
function ic_lock_small_extends() { ic_lock_small_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_lock_small_extends.apply(this, arguments); }

var SvgIcLockSmall = function SvgIcLockSmall(props) {
  return /*#__PURE__*/react.createElement("svg", ic_lock_small_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#ic_lock_small_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M9 4h-.5V3a2.5 2.5 0 0 0-5 0v1H3c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1M6 8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M4.5 4V3c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v1z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "ic_lock_small_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
/* harmony default export */ var ic_lock_small = (SvgIcLockSmall);
// EXTERNAL MODULE: ./public/icons/ic_play.svg
var ic_play = __webpack_require__(88797);
;// CONCATENATED MODULE: ./components/characters/ProfileInfoCard.tsx
function ProfileInfoCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileInfoCard_templateObject() {
    var data = ProfileInfoCard_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: ",
        "px;\n    border-radius: ",
        "px;\n    box-shadow: 3px -2px 20px 3px #0000000d;\n    overflow: hidden;\n\n    .imageContainer {\n      height: ",
        "px;\n      background-color: ",
        ";\n      position: relative;\n\n      .gradient {\n        position: absolute;\n        width: 100%;\n        height: 40px;\n        top: 0;\n        z-index: 1;\n        ",
        "\n      }\n\n      .icon-btn {\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        z-index: 10;\n        padding: 0;\n        padding: 8px 10px;\n        margin: 0;\n      }\n\n      .playCount {\n        position: absolute;\n        width: 100%;\n        top: 0;\n        display: flex;\n        gap: ",
        "px;\n        padding: 10px;\n        ",
        ";\n        color: ",
        ";\n        z-index: 10;\n\n        svg path {\n          fill: currentcolor;\n        }\n      }\n\n      .image {\n        width: 100%;\n        height: ",
        "px;\n        background-color: ",
        ";\n      }\n    }\n\n    .info {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 10px 9px ",
        "px;\n\n      .name {\n        ",
        ";\n        ",
        "\n      }\n      .age {\n        ",
        ";\n        margin-top: ",
        "px;\n        margin-bottom: ",
        "px;\n        color: ",
        ";\n        ",
        "\n      }\n      .desc {\n        ",
        ";\n        font-weight: 600;\n        ",
        "\n      }\n    }\n  "
    ]);
    ProfileInfoCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var cardContainerCSS = function(size) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(ProfileInfoCard_templateObject(), size.height, dist_esm/* Radius.small */.wU.small, size.imageHeight, theme.var.white, (0,css/* linearGradient */.bC)("top", "rgba(255, 255, 255, 0)", "rgba(0, 0, 0, 0.2)"), dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall, dist_esm/* Typography.body11 */.ZT.body11, theme.var.white, size.imageHeight, theme.var.gray200, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1), size.infoFontSize === 11 ? dist_esm/* Typography.body11 */.ZT.body11 : dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray500, (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1));
    };
};
var ProfileInfoCardSize = {
    w166: {
        width: 166,
        height: 216,
        imageHeight: 140,
        infoFontSize: 12
    },
    w128: {
        width: 128,
        height: 199,
        imageHeight: 126,
        infoFontSize: 11
    }
};
var ProfileInfoCard = function(param) {
    var data = param.data, _size = param.size, size = _size === void 0 ? "w128" : _size, isMyPage = param.isMyPage, handleActionSheet = param.handleActionSheet, handleSelectCharacter = param.handleSelectCharacter, handleCreateChat = param.handleCreateChat, handleNavigateEdit = param.handleNavigateEdit;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var information = data.information;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isTemp = data.status === "DRF";
    var isPrivate = data.status === "PRV";
    var getActionSheetValue = (0,react.useCallback)(function() {
        if (isMyPage) {
            if (isTemp) {
                return [
                    {
                        label: t("수정하기"),
                        value: "modify"
                    },
                    {
                        label: t("삭제하기"),
                        value: "delete",
                        isDanger: true
                    }, 
                ];
            } else {
                return [
                    {
                        label: t("캐릭터 상세로 가기"),
                        value: "detail"
                    },
                    {
                        label: t("수정하기"),
                        value: "modify"
                    },
                    {
                        label: t("삭제하기"),
                        value: "delete",
                        isDanger: true
                    }, 
                ];
            }
        } else {
            return [
                {
                    label: t("캐릭터 상세로 가기"),
                    value: "detail"
                },
                {
                    label: t("신고하기"),
                    value: "report",
                    isDanger: true
                }, 
            ];
        }
        return [];
    }, [
        isMyPage,
        isTemp,
        t
    ]);
    var ref = (0,react.useState)(getActionSheetValue()), actions = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: cardContainerCSS(ProfileInfoCardSize[size]),
        onClick: function() {
            return isTemp ? handleNavigateEdit(data) : handleCreateChat(data.id);
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "imageContainer",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                        className: "gradient"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "playCount",
                                children: isTemp ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    children: "임시저장"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                            icon: isPrivate ? ic_lock_small : ic_play/* default */.Z
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            children: (0,chat/* formatNumberMillion */.OQ)(data.stat.message_count)
                                        })
                                    ]
                                })
                            }),
                            handleActionSheet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* default */.Z, {
                                name: "character-card-action-".concat(data.id),
                                options: actions,
                                onSelect: function(value) {
                                    return handleActionSheet(value);
                                },
                                children: function(open) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                        className: "icon-btn",
                                        onClick: function(e) {
                                            open(e);
                                            handleSelectCharacter(data);
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                            icon: icon/* VerticalEllipsis */.oR,
                                            color: theme.var.white,
                                            size: dist_esm/* Sizes.small */.u8.small
                                        })
                                    });
                                }
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.profile_image) && (data === null || data === void 0 ? void 0 : data.profile_image.key) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: data.profile_image,
                        alt: "profile_img"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        className: "name",
                        children: information.name || "캐릭터 이름"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "age",
                        children: "".concat(information.age || "N", "세 | ").concat(information.job || "직업")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "desc",
                        children: data.greeting || "캐릭터 한마디"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var characters_ProfileInfoCard = (ProfileInfoCard);

;// CONCATENATED MODULE: ./components/characters/CharacterCardList.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function CharacterCardList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function CharacterCardList_templateObject() {
    var data = CharacterCardList_taggedTemplateLiteral([
        "\n  padding: 0 ",
        "px;\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n\n  .cheming-stat-container {\n    margin-top: 9px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    ",
        ";\n    gap: 3px;\n    margin-bottom: 21px;\n    .comment-count {\n      ",
        ";\n      color: #90949b;\n    }\n  }\n"
    ]);
    CharacterCardList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CharacterCardList_templateObject1() {
    var data = CharacterCardList_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-top: ",
        "px;\n    margin-bottom: 10px;\n\n    .dropdown {\n      > div {\n        ",
        ";\n        border: 1px solid ",
        ";\n        border-radius: ",
        "px;\n        height: 35px;\n        padding: ",
        "px;\n        background-color: ",
        ";\n      }\n      > ul {\n        z-index: 20;\n      }\n    }\n    .count {\n      ",
        ";\n    }\n  "
    ]);
    CharacterCardList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = CharacterCardList_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n  ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


























var CharacterCardList_containerCSS = function() {
    return (0,emotion_react_browser_esm.css)(CharacterCardList_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Typography.body12 */.ZT.body12);
};
var filterHeaderCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(CharacterCardList_templateObject1(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, isCheming ? "color:#7F00FF" : "", theme.var.gray300, dist_esm/* Radius.medium */.wU.medium, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.white, dist_esm/* Typography.body12 */.ZT.body12);
    };
};
var iteratorCSS = (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, css/* media.tablet */.BC.tablet, css/* media.desktop */.BC.desktop);
var CharacterCardList = function(param) {
    var userId = param.userId, isMyPage = param.isMyPage;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var web = (0,webview/* useWebView */.B9)().web;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    var options = [
        {
            label: "최신순",
            value: "id"
        },
        {
            label: "인기순",
            value: "stat__message_count"
        }, 
    ];
    var ref1 = (0,react.useState)(options[0]), orderValue = ref1[0], setOrderValue = ref1[1];
    var ref2 = (0,react.useState)(null), selectedCharacter = ref2[0], setSelectedCharacter = ref2[1];
    var ref3 = (0,react.useState)(false), isDeleteAction = ref3[0], setIsDeleteAction = ref3[1];
    var useFetchUser = (0,useUserQuery/* useUserQuery */.b)().useFetchUser;
    var ref4 = useFetchUser(userId), user = ref4.data;
    var ref5 = (0,usePlayer/* usePlayer */.n)(userId, {
        refetchOnWindowFocus: isCheming ? false : "always"
    }), player = ref5.data;
    var myCharacterQueryKey = constants/* QUERY_KEYS.CHARACTER.MY_CHARACTER_LIST */.U7.CHARACTER.MY_CHARACTER_LIST(orderValue.value);
    var myCharacterQuery = (0,query/* useChatPaginationQuery */.aI)(myCharacterQueryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchMyCharacters */.p6)({
            orderBy: orderValue.value
        }, pageParam);
    }, {
        enabled: isMyPage
    });
    var userCharacterQuery = (0,query/* useChatPaginationQuery */.aI)(constants/* QUERY_KEYS.CHARACTER.USERS */.U7.CHARACTER.USERS(userId, orderValue.value), function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchCharacters */.Em)({
            user_id: userId,
            order_by: orderValue.value,
            status: "PUB"
        }, pageParam);
    }, {
        enabled: !isMyPage
    });
    var ref6 = (0,es.useMutation)(function(characterId) {
        return (0,chatbot/* deletePlaySet */.o6)(characterId);
    }, {
        onSettled: function() {
            closeCharacterDeleteModal();
            alert("캐릭터 삭제가 완료되었습니다.");
            postChannelMessage("delete");
            constants/* QUERY_KEYS.CHAT_ROOM.LIST */.U7.CHAT_ROOM.LIST("Library");
            queryClient.invalidateQueries(constants/* QUERY_KEYS.CHAT_ROOM.LIST */.U7.CHAT_ROOM.LIST("Library"));
            queryClient.invalidateQueries(constants/* QUERY_KEYS.CHARACTER.MY_CHARACTER_LIST */.U7.CHARACTER.MY_CHARACTER_LIST(orderValue.value));
            setSelectedCharacter(null);
        }
    }), deleteCharacter = ref6.mutate;
    var ref7 = _slicedToArray((0,useModal/* useModal */.d)("character-delete"), 2), isCharacterDeleteModalOpen = ref7[0], ref8 = ref7[1], openCharacterDeleteModal = ref8.open, closeCharacterDeleteModal = ref8.close;
    (0,useScrollPosition/* useScrollPosition */.R)("userCharacterCardList:".concat(userId));
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_UPDATE */._.CHARACTER_UPDATE, function() {
        queryClient.invalidateQueries(myCharacterQueryKey);
    });
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_DELETE */._.CHARACTER_DELETE, function() {
        queryClient.invalidateQueries(myCharacterQueryKey);
    });
    var postChannelMessage = (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_DELETE */._.CHARACTER_DELETE).postChannelMessage;
    var handleSelectCharacter = function(character) {
        setSelectedCharacter(character);
    };
    var handleCreateChat = function() {
        var _ref = _asyncToGenerator(function(characterId) {
            var data;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chatbot/* fetchSituations */.XZ)({
                                character_id: characterId
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (data && data.items[0].id) {
                            if (platform === constants/* Platform.web */.t4.web) {
                                router.push("/play/situations/".concat(data.items[0].id, "/chat-room"));
                            } else {
                                web.openPage("/play/situations/".concat(data.items[0].id, "/chat-room"));
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreateChat(characterId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNavigateCreate = function() {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/create");
        }
        web.openPage("/play/characters/create");
    };
    var handleNavigateEdit = function(character) {
        var type = (character === null || character === void 0 ? void 0 : character.can_have_visual) ? "visual" : "default";
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(character.id, "/edit?characterType=").concat(type));
        }
        web.openPage("/play/characters/".concat(character.id, "/edit?characterType=").concat(type));
    };
    var handleNavigateChemingEdit = function(character) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(character.id, "/edit"));
        }
        web.openPage("/play/characters/".concat(character.id, "/edit"));
    };
    var handleConfirmDeleteCharacter = function(characterId) {
        deleteCharacter(characterId);
        setSelectedCharacter(null);
    };
    var handleActionSheet = function(value) {
        if (selectedCharacter) {
            var type = (selectedCharacter === null || selectedCharacter === void 0 ? void 0 : selectedCharacter.can_have_visual) ? "visual" : "default";
            switch(value){
                case "modify":
                    setIsDeleteAction(false);
                    if (platform === constants/* Platform.web */.t4.web) {
                        router.push("/play/characters/".concat(selectedCharacter.id, "/edit?characterType=").concat(type));
                    }
                    web.openPage("/play/characters/".concat(selectedCharacter.id, "/edit?characterType=").concat(type));
                    break;
                case "delete":
                    if (selectedCharacter.status === "DRF") {
                        if (confirm("정말 삭제하시겠습니까?")) {
                            handleConfirmDeleteCharacter(selectedCharacter.id);
                        }
                    } else {
                        setIsDeleteAction(true);
                        openCharacterDeleteModal();
                    }
                    break;
                case "detail":
                    setIsDeleteAction(false);
                    if (platform === constants/* Platform.web */.t4.web) {
                        router.push("/play/characters/".concat(selectedCharacter.id));
                    }
                    web.openPage("/play/characters/".concat(selectedCharacter.id));
                    break;
                case "report":
                    if (platform === constants/* Platform.web */.t4.web) {
                        router.push("/report".concat((0,misc/* toQueryString */.UK)({
                            objectType: constants/* ReportObjectType.character */.LB.character,
                            object_id: selectedCharacter.id
                        })));
                    }
                    web.openPage("/report".concat((0,misc/* toQueryString */.UK)({
                        objectType: constants/* ReportObjectType.character */.LB.character,
                        object_id: selectedCharacter.id
                    })));
                    break;
                default:
                    break;
            }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: CharacterCardList_containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_PlayCountCard, {
                isMyPage: isMyPage,
                user: user,
                player: player
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: filterHeaderCSS(isCheming),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_form/* Select */.Ph, {
                        className: "dropdown",
                        name: "order",
                        fontSize: dist_esm/* FontSizes.small */.TS.small,
                        options: options,
                        selected: orderValue,
                        onChange: function(values) {
                            return setOrderValue(values);
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "count",
                        children: t("{{count}}개의 캐릭터", {
                            count: isMyPage ? (0,misc/* formatComma */.cO)(myCharacterQuery === null || myCharacterQuery === void 0 ? void 0 : myCharacterQuery.totalCount) : (0,misc/* formatComma */.cO)(userCharacterQuery === null || userCharacterQuery === void 0 ? void 0 : userCharacterQuery.totalCount)
                        })
                    })
                ]
            }),
            isMyPage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "my-character-card-list",
                query: myCharacterQuery,
                css: iteratorCSS,
                ad: isMyPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_CharacterAddCard, {
                    handleOnClick: handleNavigateCreate,
                    isCheming: isCheming
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_ProfileInfoCard, {
                        data: item,
                        handleActionSheet: handleActionSheet,
                        handleSelectCharacter: handleSelectCharacter,
                        isMyPage: isMyPage,
                        size: "w166",
                        handleCreateChat: handleCreateChat,
                        handleNavigateEdit: isCheming ? handleNavigateChemingEdit : handleNavigateEdit
                    });
                }
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "user-character-card-list",
                query: userCharacterQuery,
                css: iteratorCSS,
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_ProfileInfoCard, {
                        data: item,
                        handleActionSheet: handleActionSheet,
                        handleSelectCharacter: handleSelectCharacter,
                        isMyPage: false,
                        size: "w166",
                        handleCreateChat: handleCreateChat,
                        handleNavigateEdit: isCheming ? handleNavigateChemingEdit : handleNavigateEdit
                    });
                }
            }),
            !isMyPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: userCharacterQuery,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("아직 캐릭터가 없습니다.")
                })
            }),
            isDeleteAction && selectedCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterDeleteModal/* default */.Z, {
                open: isCharacterDeleteModalOpen,
                onClose: closeCharacterDeleteModal,
                handleOnConfirm: handleConfirmDeleteCharacter,
                character: selectedCharacter
            })
        ]
    });
};
/* harmony default export */ var characters_CharacterCardList = (CharacterCardList);


/***/ }),

/***/ 83898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ KebabMenu; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48294);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30259);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81946);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin: 0;\n  top: -",
        "px;\n  right: -",
        "px;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ACTION_SHEET_MODAL_PREFIX = "__action-sheet";
var ActionSheet = function(param) {
    var name = param.name, options = param.options, children = param.children, onSelect = param.onSelect;
    var ref = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_6__/* .useWebView */ .B9)(), web = ref.web, listen = ref.listen;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().platform;
    var actionSheetName = "".concat(ACTION_SHEET_MODAL_PREFIX, "-").concat(name);
    var ref1 = _slicedToArray((0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)(actionSheetName, {
        routeChange: false,
        trigger: false
    }), 2), open = ref1[1].open;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.stopPropagation();
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_4__/* .Platform.web */ .t4.web) {
            open(options);
        } else {
            web.openActionSheet(actionSheetName, options);
        }
    }, [
        platform,
        actionSheetName,
        options
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var unlisten = listen("actionSheetSelect", function(e) {
            var _detail = e.detail, name = _detail.name, index = _detail.value;
            if (name !== actionSheetName) {
                return;
            }
            var value = options[index] ? options[index].value : undefined;
            if (value) {
                onSelect(value);
            }
        });
        return unlisten;
    }, [
        options,
        onSelect
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
        children: children === null || children === void 0 ? void 0 : children(handleClick)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActionSheet);
/**
 * 케밥 형태
 */ var kebabMenuCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium);
var KebabMenu = function(_param) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ActionSheet, _objectSpreadProps(_objectSpread({}, props), {
        children: function(open) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("aside", {
                className: className,
                css: kebabMenuCSS,
                onClick: open,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .VerticalEllipsis */ .oR,
                    color: theme.var.gray500,
                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small
                })
            });
        }
    }));
};


/***/ }),

/***/ 11247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ EFinderImageSizes; },
/* harmony export */   "yK": function() { return /* binding */ OptimizeEFinderImage; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26410);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 0.5s linear forwards;\n  overflow: hidden;\n  border-radius: inherit;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var fadeInKeyframes = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)(_templateObject());
var imageCSS = function(radius) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), fadeInKeyframes, radius && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1(), typeof radius === "string" ? radius : "".concat(radius, "px")));
};
var ratio = 2;
var EFinderImage = function(_param) {
    var className = _param.className, image = _param.image, h = _param.h, radius = _param.radius, width = _param.width, height = _param.height, alt = _param.alt, objectFit = _param.objectFit, objectPosition = _param.objectPosition, loading = _param.loading, layout = _param.layout, priority = _param.priority, rest = _objectWithoutProperties(_param, [
        "className",
        "image",
        "h",
        "radius",
        "width",
        "height",
        "alt",
        "objectFit",
        "objectPosition",
        "loading",
        "layout",
        "priority"
    ]);
    if (!image || !image.attachment) {
        return null;
    }
    var _attachment = image.attachment, url = _attachment.url, contentType = _attachment.contentType, attachmentHeight = _attachment.height;
    var bgUrl = contentType === "image/gif" || h === undefined ? url : "".concat(url, "?t=h&d=").concat(h ? h * ratio : attachmentHeight);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), _objectSpreadProps(_objectSpread({
        css: imageCSS(radius),
        className: className
    }, rest), {
        src: bgUrl,
        width: width,
        height: height,
        layout: layout || "fill",
        loading: loading || "lazy",
        objectFit: objectFit || "cover",
        alt: alt,
        objectPosition: objectPosition || "center",
        unoptimized: true,
        priority: !!priority
    }));
};
var OptimizeEFinderImage = function(_param) {
    var className = _param.className, image = _param.image, h = _param.h, radius = _param.radius, width = _param.width, height = _param.height, alt = _param.alt, objectFit = _param.objectFit, objectPosition = _param.objectPosition, loading = _param.loading, layout = _param.layout, priority = _param.priority, rest = _objectWithoutProperties(_param, [
        "className",
        "image",
        "h",
        "radius",
        "width",
        "height",
        "alt",
        "objectFit",
        "objectPosition",
        "loading",
        "layout",
        "priority"
    ]);
    if (!image || !image.attachment) {
        return null;
    }
    var _attachment = image.attachment, url = _attachment.url, contentType = _attachment.contentType, attachmentHeight = _attachment.height;
    var myLoader = function(param) {
        var src = param.src, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
        return "".concat(src, "&q=").concat(quality);
    };
    var bgUrl = contentType === "image/gif" || h === undefined ? url : "".concat(url, "?t=h&d=").concat(h ? h * ratio : attachmentHeight);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), _objectSpreadProps(_objectSpread({
        css: imageCSS(radius),
        className: className
    }, rest), {
        src: bgUrl,
        width: width,
        height: height,
        loader: myLoader,
        layout: layout || "fill",
        loading: loading || (priority ? "eager" : "lazy"),
        objectFit: objectFit || "cover",
        alt: alt,
        objectPosition: objectPosition || "center",
        priority: !!priority
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (EFinderImage);
var EFinderImageSizes;
(function(EFinderImageSizes) {
    EFinderImageSizes[EFinderImageSizes["marketItem"] = 80] = "marketItem";
    EFinderImageSizes[EFinderImageSizes["banner"] = 420] = "banner";
    EFinderImageSizes[EFinderImageSizes["avatar"] = 64] = "avatar";
    EFinderImageSizes[EFinderImageSizes["chatbot"] = 150] = "chatbot";
})(EFinderImageSizes || (EFinderImageSizes = {}));


/***/ }),

/***/ 85496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ cdnLoader; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8683);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26410);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function cdnLoader(param) {
    var src = param.src, width = param.width;
    return "".concat(src, "?w=").concat(width);
}
var Image = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), _objectSpreadProps(_objectSpread({}, props), {
        loader: cdnLoader
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 81794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11247);
/* harmony import */ var _components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34368);
/* harmony import */ var _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42079);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: 100px;\n  overflow: hidden;\n  img {\n    ",
        ";\n  }\n\n  i {\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var avatarWrapCSS = function(size) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), size, size);
};
var avatarCSS = function(size, blurValue) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), size, size, blurValue ? "filter: blur(".concat(blurValue, "px)") : null);
};
var RoundAvatar = function(param) {
    var _size = param.size, size = _size === void 0 ? 44 : _size, picture = param.picture, className = param.className, blurValue = param.blurValue, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* .EFinderImageSizes.avatar */ .ny.avatar : _imageSize;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        css: avatarWrapCSS(size),
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            css: avatarCSS(size, blurValue),
            className: "avatar-container",
            children: picture && picture.key ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
                image: picture,
                h: imageSize,
                radius: 100
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                icon: _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                d: size
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RoundAvatar);


/***/ }),

/***/ 14054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55277);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Seo = function(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpreadProps(_objectSpread({}, props), {
        title: "".concat(title, " - ").concat(t("채티"))
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 95728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
// SwipeableListContainer.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var listContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject());
var SwipeableListContainer = function(param) {
    var children = param.children, className = param.className;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var startX = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var scrollLeft = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var el = containerRef.current;
        if (!el) return;
        var handleMouseDown = function(e) {
            isDragging.current = true;
            startX.current = e.pageX - el.offsetLeft;
            scrollLeft.current = el.scrollLeft;
            el.style.cursor = "grabbing";
        };
        var handleMouseMove = function(e) {
            if (!isDragging.current) return;
            e.preventDefault();
            var x = e.pageX - el.offsetLeft;
            var walk = (x - startX.current) * 1.2;
            el.scrollLeft = scrollLeft.current - walk;
        };
        var handleMouseUp = function() {
            isDragging.current = false;
            el.style.cursor = "grab";
        };
        el.addEventListener("mousedown", handleMouseDown);
        el.addEventListener("mousemove", handleMouseMove);
        el.addEventListener("mouseleave", handleMouseUp);
        el.addEventListener("mouseup", handleMouseUp);
        return function() {
            el.removeEventListener("mousedown", handleMouseDown);
            el.removeEventListener("mousemove", handleMouseMove);
            el.removeEventListener("mouseleave", handleMouseUp);
            el.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: listContainerCSS,
        className: className,
        ref: containerRef,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwipeableListContainer);


/***/ }),

/***/ 959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54909);
/* harmony import */ var _hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80786);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9150);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38945);
/* harmony import */ var _components_common_Empty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34270);
/* harmony import */ var _components_common_Pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39753);
/* harmony import */ var _components_layout_Pad__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95833);
/* harmony import */ var _api_community__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1385);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30259);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97033);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45874);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96261);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81946);
/* harmony import */ var _Post__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23468);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px;\n  button {\n    box-shadow: none;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: ",
        "px;\n  font-weight: 600;\n  flex: 1 1 0px;\n  height: 48px;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




















var writeButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Spacing.medium */ .Ki.medium);
var userButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Radius.medium */ .wU.medium);
var PostList = function(param) {
    var userId = param.userId, isMyPage = param.isMyPage;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_16__/* .useWebView */ .B9)().web;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_12__/* .useGlobalContext */ .bN)().platform;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQueryClient)();
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_13__/* .useUserMarketItemInventory */ .wg)(userId), data = ref.data, getDecoration = ref.getDecoration;
    var profileBtnDecoration = getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_11__/* .MarketItemType.profileBtn */ .q9.profileBtn);
    var queryKey = _constants__WEBPACK_IMPORTED_MODULE_11__/* .QUERY_KEYS.POST.USER_LIST */ .U7.POST.USER_LIST(userId);
    var query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_15__/* .usePaginationQuery */ .Zl)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,_api_community__WEBPACK_IMPORTED_MODULE_10__/* .fetchUserPosts */ .bg)(userId, pageParam);
    }, {
        refetchOnWindowFocus: "always"
    });
    var optimistic = (0,_utils_query__WEBPACK_IMPORTED_MODULE_15__/* .useOptimisticUpdate */ .p7)();
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(_api_community__WEBPACK_IMPORTED_MODULE_10__/* .togglePostLike */ ._P), toggleLike = ref1.mutate;
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(postId) {
        return (0,_api_community__WEBPACK_IMPORTED_MODULE_10__/* .deleteMyCommunityPost */ .VH)(postId);
    }), removePost = ref2.mutate;
    (0,_hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_4__/* .useScrollPosition */ .R)("userPostList:".concat(userId));
    var likePost = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(post) {
        toggleLike(post.id, {
            onSuccess: function(param) {
                var isLiked = param.isLiked;
                optimistic.update(queryKey, function(post) {
                    return _objectSpreadProps(_objectSpread({}, post), {
                        isLiked: isLiked,
                        likeCount: post.likeCount + (isLiked ? 1 : -1)
                    });
                }, {
                    id: post.id
                });
            }
        });
    }, []);
    var pollVote = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(post) {
        optimistic.update(queryKey, function(p) {
            return _objectSpreadProps(_objectSpread({}, p), {
                poll: post.poll
            });
        }, {
            id: post.id
        });
        var feedQueries = queryClient.getQueriesData([
            "communityFeed"
        ]);
        feedQueries.forEach(function(param) {
            var _param = _slicedToArray(param, 1), key = _param[0];
            optimistic.update(key, function(p) {
                return _objectSpreadProps(_objectSpread({}, p), {
                    poll: post.poll
                });
            }, {
                id: post.id
            });
        });
        queryClient.invalidateQueries([
            "communityFeed"
        ]);
        queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_11__/* .QUERY_KEYS.FOLLOWING.FEED */ .U7.FOLLOWING.FEED);
        queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_11__/* .QUERY_KEYS.POST.ONE */ .U7.POST.ONE(post.id));
    }, []);
    var handleNavigatePostCreate = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_11__/* .Platform.web */ .t4.web) {
            router.push("/feeds/posts/create");
        }
        web.openPage("/feeds/posts/create");
    };
    var handleNavigatePostDetail = function(id) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_11__/* .Platform.web */ .t4.web) {
            router.push("/feeds/posts/".concat(id));
        }
        web.openPage("/feeds/posts/".concat(id));
    };
    var handleDeletePost = function(id) {
        if (confirm(t("정말 게시글을 삭제하시겠습니까?"))) {
            removePost(id, {
                onSuccess: function() {
                    return queryClient.invalidateQueries(queryKey);
                }
            });
        }
    };
    var handleActionSheet = function(value, id) {
        switch(value){
            case "modify":
                if (platform === _constants__WEBPACK_IMPORTED_MODULE_11__/* .Platform.web */ .t4.web) {
                    router.push("/feeds/posts/create/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
                        postId: id
                    })));
                }
                web.openPage("/feeds/posts/create/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
                    postId: id
                })));
                break;
            case "delete":
                handleDeletePost(id);
                break;
            case "report":
                router.push("/report".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
                    objectType: _constants__WEBPACK_IMPORTED_MODULE_11__/* .ReportObjectType.community */ .LB.community,
                    objectId: id
                })));
                break;
            default:
                return;
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
        children: [
            isMyPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                css: writeButtonCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_6__/* .DecoratedButton */ .b, {
                    css: userButtonCSS,
                    decoration: profileBtnDecoration,
                    onClick: handleNavigatePostCreate,
                    children: "새로운 게시글 쓰기"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Pagination__WEBPACK_IMPORTED_MODULE_8__/* .PaginationIterator */ .gt, {
                name: "user-post-list",
                query: query,
                border: true,
                children: function(item) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_layout_Pad__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        onClick: function() {
                            return handleNavigatePostDetail(item.id);
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_Post__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, item), {
                            clip: true,
                            onLike: likePost,
                            onPollVote: pollVote,
                            isMyPage: isMyPage,
                            handleActionSheet: handleActionSheet
                        }))
                    });
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Empty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                query: query,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
                    children: t("작성한 게시글이 없습니다.")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostList);


/***/ }),

/***/ 60280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61527);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82740);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81946);
/* harmony import */ var _common_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59585);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: scroll;\n\n  .title {\n    ",
        ";\n    text-align: center;\n    line-height: 16px;\n    font-weight: 700;\n    margin-bottom: ",
        "px;\n    padding-top: ",
        "px;\n  }\n  .close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n  }\n\n  p {\n    ",
        ";\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        "px;\n    margin: ",
        "px 0;\n    gap: ",
        "px;\n  }\n\n  ul > li {\n    word-break: break-all;\n    ",
        ";\n    list-style-type: disc;\n    color: ",
        ";\n    line-height: 18.9px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.h4 */ .ZT.h4, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xhsmall */ .Ki.xhsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.h5 */ .ZT.h5, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body14 */ .ZT.body14, theme.colors.red500);
};
var CharacterDeleteModal = function(_param) {
    var handleOnConfirm = _param.handleOnConfirm, character = _param.character, props = _objectWithoutProperties(_param, [
        "handleOnConfirm",
        "character"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_5__/* .useWebView */ .B9)().web;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), value = ref[0], setValue = ref[1];
    var handleChangeInput = function(e) {
        setValue(e.currentTarget.value);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        web.setIsBottomInputPage(true);
        return function() {
            web.setIsBottomInputPage(false);
        };
    }, [
        web
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({}, props), {
        blocking: false,
        onClose: props.onClose,
        header: false,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: containerCSS,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "close",
                    onClick: function() {
                        return props.onClose();
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "title",
                    children: t("캐릭터 삭제")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                    children: t("정말 {{characterName}} 캐릭터를 삭제하시겠습니까?", {
                        characterName: character.name
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
                            children: t("캐릭터 삭제 시 해당 캐릭터와 대화했던 모든 대화방이 삭제됩니다.")
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
                            children: t("캐릭터 삭제를 원하신다면 캐릭터명을 아래 입력하신 후 삭제하기 버튼을 눌러주세요.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_form__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .II, {
                    placeholder: "캐릭터명을 입력해주세요",
                    value: value,
                    onChange: handleChangeInput
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* .ModalButton */ .mH, {
                    text: t("삭제하기"),
                    onClick: function() {
                        return handleOnConfirm(character.id);
                    },
                    disabled: value !== character.name
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CharacterDeleteModal);


/***/ }),

/***/ 94942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80786);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38945);
/* harmony import */ var _components_common_Empty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34270);
/* harmony import */ var _components_common_NativeInFeedAd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80521);
/* harmony import */ var _components_common_Pagination__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39753);
/* harmony import */ var _api_story__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10741);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30259);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97033);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96261);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81946);
/* harmony import */ var _Story__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1028);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px;\n  button {\n    box-shadow: none;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: ",
        "px;\n  font-weight: 600;\n  flex: 1 1 0px;\n  height: 48px;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var writeButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium);
var userButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.medium */ .wU.medium);
var StoryList = function(param) {
    var userId = param.userId, isMyPage = param.isMyPage;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_13__/* .useWebView */ .B9)().web;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_10__/* .useGlobalContext */ .bN)().platform;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_11__/* .useUserMarketItemInventory */ .wg)(userId), data = ref.data, getDecoration = ref.getDecoration;
    var profileBtnDecoration = getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_9__/* .MarketItemType.profileBtn */ .q9.profileBtn);
    var myStoryQuery = (0,_utils_query__WEBPACK_IMPORTED_MODULE_12__/* .usePaginationQuery */ .Zl)([
        "myStoryList",
        userId
    ], function(param) {
        var pageParam = param.pageParam;
        return (0,_api_story__WEBPACK_IMPORTED_MODULE_8__/* .fetchMyStories */ .PS)(undefined, pageParam);
    }, {
        refetchOnWindowFocus: "always"
    });
    (0,_hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_2__/* .useScrollPosition */ .R)("userStoryList:".concat(userId));
    var userStoryQuery = (0,_utils_query__WEBPACK_IMPORTED_MODULE_12__/* .usePaginationQuery */ .Zl)([
        "userStoryList",
        userId
    ], function(param) {
        var pageParam = param.pageParam;
        return (0,_api_story__WEBPACK_IMPORTED_MODULE_8__/* .fetchUserStories */ .uw)(userId, pageParam);
    }, {
        refetchOnWindowFocus: "always"
    });
    (0,_hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_2__/* .useScrollPosition */ .R)("userStoryList:".concat(userId));
    var handleNavigateStudio = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_9__/* .Platform.web */ .t4.web) {
            router.push("/studio/stories/create");
        }
        web.openPage("/studio/stories/create");
    };
    var handleNavigateStoryDetail = function(story) {
        var url = isMyPage ? "/studio/stories/".concat(story.id) : story.theme === _constants__WEBPACK_IMPORTED_MODULE_9__/* .StoryTheme.iknow */ .xb.iknow ? "/stories/".concat(story.id, "/licensed") : "/stories/".concat(story.id);
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_9__/* .Platform.web */ .t4.web) {
            router.push(url);
        }
        web.openPage(url);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
        children: [
            isMyPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                css: writeButtonCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_4__/* .DecoratedButton */ .b, {
                    css: userButtonCSS,
                    decoration: profileBtnDecoration,
                    onClick: handleNavigateStudio,
                    children: "새로운 작품쓰기"
                })
            }),
            isMyPage ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_Pagination__WEBPACK_IMPORTED_MODULE_7__/* .PaginationIterator */ .gt, {
                name: "user-story-list",
                query: myStoryQuery,
                border: true,
                children: function(item) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Story__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({}, item), {
                        onClick: function() {
                            return handleNavigateStoryDetail(item);
                        },
                        isMyPage: true
                    }));
                }
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_Pagination__WEBPACK_IMPORTED_MODULE_7__/* .PaginationIterator */ .gt, {
                name: "user-story-list",
                query: userStoryQuery,
                border: true,
                inFeedAd: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_NativeInFeedAd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    unitKey: "home_cp_mobile"
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Story__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({}, item), {
                        onClick: function() {
                            return handleNavigateStoryDetail(item);
                        }
                    }));
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_Empty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                query: isMyPage ? myStoryQuery : userStoryQuery,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("p", {
                    children: t("작품이 없습니다.")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StoryList);


/***/ }),

/***/ 27425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ user_UserInfo; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useUserQuery.ts
var useUserQuery = __webpack_require__(75319);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/common/Avatar.tsx
var Avatar = __webpack_require__(81649);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(38945);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(59585);
;// CONCATENATED MODULE: ./components/modal/FanClubModal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  line-height: 1.35;\n\n  h5 {\n    margin-bottom: ",
        "px;\n  }\n\n  p {\n    font-size: ",
        "px;\n    white-space: pre-line;\n    color: ",
        ";\n    padding: ",
        "px;\n    border-radius: ",
        "px;\n    font-size: ",
        "px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FanClubModalCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray800, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Radius.medium */.wU.medium, dist_esm/* FontSizes.small */.TS.small, theme.var.gray600);
};
var FanClubModal = function(_param) {
    var props = _extends({}, _param);
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* default */.ZP, _objectSpreadProps(_objectSpread({}, props), {
        header: false,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: FanClubModalCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        children: t("팬클럽")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: t("작가님의 작품을 후원하여\n작가님의 팬클럽에 가입해주세요!.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                text: t("확인")
            })
        ]
    }));
};
/* harmony default export */ var modal_FanClubModal = (FanClubModal);

;// CONCATENATED MODULE: ./components/modal/SubscriptionErrorModal.tsx
function SubscriptionErrorModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SubscriptionErrorModal_extends() {
    SubscriptionErrorModal_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return SubscriptionErrorModal_extends.apply(this, arguments);
}
function SubscriptionErrorModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SubscriptionErrorModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SubscriptionErrorModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SubscriptionErrorModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SubscriptionErrorModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SubscriptionErrorModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SubscriptionErrorModal_templateObject() {
    var data = SubscriptionErrorModal_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        "px;\n  align-items: center;\n  align-self: stretch;\n  ",
        ";\n  padding-right: ",
        "px;\n  padding-left: ",
        "px;\n"
    ]);
    SubscriptionErrorModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var dottedCSS = (0,emotion_react_browser_esm.css)(SubscriptionErrorModal_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium);
var SubscriptionErrorModal = function(_param) {
    var props = SubscriptionErrorModal_extends({}, _param);
    var t = (0,esm/* useTranslation */.$G)().t;
    var onClose = props.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* default */.ZP, SubscriptionErrorModal_objectSpreadProps(SubscriptionErrorModal_objectSpread({}, props), {
        title: t("문제가 생겼어요"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: dottedCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    className: "multiline",
                    children: t("저희 측 서버 오류로 인해\n회원님의 구독 상품이 성공적으로 구매되지 않았어요.\n결제하신 금액은 최소 3일 이후에\n자동으로 환불 될 예정이에요.\n불편을 드려 죄송합니다.")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                text: t("확인했어요"),
                onClick: function() {
                    return onClose();
                }
            })
        ]
    }));
};
/* harmony default export */ var modal_SubscriptionErrorModal = (SubscriptionErrorModal);

// EXTERNAL MODULE: ./components/user/Nickname.tsx
var Nickname = __webpack_require__(87682);
;// CONCATENATED MODULE: ./public/icons/ic_free_balloon.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;
function ic_free_balloon_extends() { ic_free_balloon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_free_balloon_extends.apply(this, arguments); }

var SvgIcFreeBalloon = function SvgIcFreeBalloon(props) {
  return /*#__PURE__*/react.createElement("svg", ic_free_balloon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#EF4239",
    fillRule: "evenodd",
    d: "M5.424 9.27s-.899 1.081-.077 1.17h.91s.548-.106.105-.815l-.336-.354",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M5.424 9.27s-.899 1.081-.077 1.17h.91s.548-.106.105-.815l-.336-.354"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFB21C",
    fillRule: "evenodd",
    d: "M9.267 9.439s.133.425-.105.788c0 0-.378.46-.804.124 0 0-.812-.497-.245-.852 0 0 .277-.202.606-.324",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M9.267 9.439s.133.425-.105.788c0 0-.378.46-.804.124 0 0-.812-.497-.245-.852 0 0 .277-.202.606-.324M5.768 10.44c.154.484.545 1.578 1.406 2.435 0 0 1.032 1.26.585 2.403"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M8.282 10.3s-1.392 1.203-.897 2.903c0 0 .403.744-.978 1.98"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M7.488 13.393s-1.685-1.24-2.1.155c0 0 .03 1.316 2.052-.053 0 0 .835-2.382 1.722-1.155 0 0 .654.987-1.674 1.053",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFB21C",
    fillRule: "evenodd",
    d: "M8.269 3.528c.795-.834 1.918-1.227 2.996-.932 1.655.452 2.576 2.356 2.058 4.253-.519 1.896-2.28 3.067-3.936 2.614-.727-.199-1.312-.677-1.696-1.313",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M8.269 3.528c.795-.834 1.918-1.227 2.996-.932 1.655.452 2.576 2.356 2.058 4.253-.519 1.896-2.28 3.067-3.936 2.614-.727-.199-1.312-.677-1.696-1.313"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#EF4239",
    fillRule: "evenodd",
    d: "M8.449 4.439c.243 2.265-.923 4.545-2.695 4.736-1.773.19-3.48-1.782-3.724-4.048C1.787 2.862 3.027.871 4.8.681 6.572.491 8.206 2.174 8.449 4.44",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M8.449 4.439c.243 2.265-.923 4.545-2.695 4.736-1.773.19-3.48-1.782-3.724-4.048C1.787 2.862 3.027.871 4.8.681 6.572.491 8.206 2.174 8.449 4.44",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 5.333,
    height: 5.333,
    x: 10.667,
    fill: "#EF4239",
    rx: 2.667
  })));
};
/* harmony default export */ var ic_free_balloon = (SvgIcFreeBalloon);
// EXTERNAL MODULE: ./api/balloon.ts
var api_balloon = __webpack_require__(81572);
// EXTERNAL MODULE: ./api/user.ts
var api_user = __webpack_require__(9622);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./utils/date.ts + 31 modules
var date = __webpack_require__(9987);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/user/UserInfo.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function UserInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function UserInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UserInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function UserInfo_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function UserInfo_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        UserInfo_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function UserInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function UserInfo_templateObject() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  z-index: 0;\n"
    ]);
    UserInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: ",
        "px;\n  padding-top: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  > h3 {\n    position: relative;\n    z-index: 1;\n    margin-top: ",
        "px;\n  }\n\n  > p {\n    margin-top: ",
        "px;\n    font-size: ",
        "px;\n    background-color: ",
        "80;\n  }\n  .avatarContainer {\n    display: flex;\n    justify-content: center;\n    position: relative;\n  }\n  .modifyBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    border-radius: ",
        "px;\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -3px;\n    margin-left: 50px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = UserInfo_taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n\n  p + h6 {\n    margin-top: ",
        "px;\n  }\n\n  p {\n    ",
        "\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0px ",
        "px;\n  display: flex;\n  padding-top: ",
        "px;\n  background-color: ",
        "80;\n\n  dl {\n    width: 25%;\n    text-align: center;\n\n    dt {\n      font-weight: 600;\n      font-size: ",
        "px;\n      margin-bottom: ",
        "px;\n    }\n\n    dd {\n      font-size: ",
        "px;\n      color: ",
        ";\n    }\n  }\n\n  dl + dl {\n    border-left: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        "px;\n  margin-left: -",
        "px;\n  margin-right: -",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  flex: 1 1 0px;\n  height: 36px;\n  border-radius: ",
        "px;\n  margin: 0 ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 48px;\n  padding: ",
        "px ",
        "px;\n  margin: ",
        "px 0px;\n  border-radius: 5px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n\n  justify-content: space-between;\n  align-items: center;\n\n  .info {\n    display: flex;\n    gap: ",
        "px;\n    height: 14px;\n    align-items: center;\n\n    p {\n      ",
        ";\n      line-height: 100%;\n    }\n  }\n  .slash {\n    ",
        ";\n    line-height: 100%;\n  }\n  .highlight {\n    color: ",
        ";\n  }\n  .weight {\n    font-weight: 700;\n  }\n  .arrow-container {\n    height: 14px;\n    display: flex;\n    gap: 2px;\n    align-items: center;\n    color: ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = UserInfo_taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n\n  .container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: ",
        "px ",
        "px;\n    background: ",
        ";\n    ",
        ";\n    border-radius: 5px;\n    border: 1px solid ",
        ";\n\n    div {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n    }\n    svg {\n      margin-right: ",
        "px;\n    }\n    .highlight {\n      color: ",
        ";\n      font-family: 'Apple SD Gothic Neo';\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 100%;\n      margin-left: 2px;\n    }\n\n    .red {\n      color: ",
        " !important;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



























var userBackgroundCSS = (0,emotion_react_browser_esm.css)(UserInfo_templateObject());
var userInfoWrapCSS = function(hasBackground) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), dist_esm/* Spacing.medium */.Ki.medium, hasBackground ? "16.6666%" : "".concat(dist_esm/* Spacing.xxlarge */.Ki.xxlarge, "px"));
};
var userCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.small */.Ki.small, dist_esm/* FontSizes.small */.TS.small, theme.var.white, dist_esm/* Radius.round */.wU.round, theme.var.white, theme.colors.main500);
};
var userAvatarCSS = (0,emotion_react_browser_esm.css)(_templateObject3());
var userBanCSS = (0,emotion_react_browser_esm.css)(_templateObject4(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Spacing.xsmall */.Ki.xsmall);
var userNumericInfoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.medium */.Ki.medium, theme.var.white, dist_esm/* FontSizes.small */.TS.small, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray600, theme.var.gray100);
};
var userButtonWrapCSS = (0,emotion_react_browser_esm.css)(_templateObject6(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
var userButtonCSS = (0,emotion_react_browser_esm.css)(_templateObject7(), dist_esm/* FontSizes.xsmall */.TS.xsmall, dist_esm/* Radius.small */.wU.small, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
var balloonContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject8(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray100, theme.var.gray50, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Typography.body12 */.ZT.body12, theme.colors.main500, theme.var.gray500, dist_esm/* Typography.body12 */.ZT.body12);
};
var subscriptionCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject9(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.small */.Ki.small, theme.colors.main50, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray100, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, theme.colors.main500, theme.colors.red500);
};
var UserInfo = function(param) {
    var userId = param.userId, isMyPage = param.isMyPage, _balloon = param.balloon, balloon = _balloon === void 0 ? false : _balloon, _subscription = param.subscription, subscription = _subscription === void 0 ? false : _subscription;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,esm/* useTranslation */.$G)().t;
    var web = (0,webview/* useWebView */.B9)().web;
    var ref11 = (0,global/* useGlobalContext */.bN)(), platform = ref11.platform, version = ref11.version, goodsName = ref11.goodsName, isCheming = ref11.isCheming;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var useFetchUser = (0,useUserQuery/* useUserQuery */.b)().useFetchUser;
    var ref12 = useFetchUser(userId, {
        refetchOnWindowFocus: "always"
    }), user = ref12.data;
    var ref13 = (0,hook/* useMe */.Pi)(), me = ref13.data;
    var query = (0,utils_query/* usePaginationQuery */.Zl)(constants/* QUERY_KEYS.SUBSCRIPTIONS.ME */.U7.SUBSCRIPTIONS.ME, function(param) {
        var pageParam = param.pageParam;
        return (0,api_balloon/* fetchMySubscriptions */.nw)(pageParam);
    }, {
        enabled: !!subscription,
        refetchOnWindowFocus: "always"
    });
    var ref14 = _slicedToArray((0,useModal/* useModal */.d)("subs-error-modal"), 2), isSubsErrorModalOpen = ref14[0], ref15 = ref14[1], openSubsErrorModal = ref15.open, closeSubsErrorModal = ref15.close;
    var subscriptionState = query === null || query === void 0 ? void 0 : (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.status;
    var subscriptionItem = query === null || query === void 0 ? void 0 : (ref5 = query.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.pages) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.items) === null || ref8 === void 0 ? void 0 : ref8[0];
    var current = new Date();
    var onHourAfterSubscribedTime = (subscriptionItem === null || subscriptionItem === void 0 ? void 0 : subscriptionItem.subscribedAt) ? (0,date/* addDuration */.WK)(subscriptionItem === null || subscriptionItem === void 0 ? void 0 : subscriptionItem.subscribedAt, {
        hours: 1
    }) : undefined;
    var isAfterOneHourFromSubscription = onHourAfterSubscribedTime ? (0,date/* isAfter */.Ax)(current, onHourAfterSubscribedTime) : false;
    var isInProgress = subscriptionState === constants/* SubscriptionState.inProgress */.jc.inProgress || subscriptionState === constants/* SubscriptionState.inGracePeriod */.jc.inGracePeriod;
    var isExpired = subscriptionState === constants/* SubscriptionState.expired */.jc.expired || subscriptionState === constants/* SubscriptionState.canceled */.jc.canceled;
    var isInHold = subscriptionState === constants/* SubscriptionState.onHold */.jc.onHold;
    var isPending = subscriptionState === constants/* SubscriptionState.pending */.jc.pending && isAfterOneHourFromSubscription;
    (0,hook/* useUserMarketItemInventories */.dV)([
        user
    ]);
    var ref16 = (0,hook/* useUserMarketItemInventory */.wg)(user === null || user === void 0 ? void 0 : user.id), data = ref16.data, getDecoration = ref16.getDecoration;
    var optimistic = (0,utils_query/* useOptimisticUpdate */.p7)();
    var ref17 = (0,es.useMutation)(api_user/* postToggleFollowUser */.dt), toggleFollow = ref17.mutate;
    var router = (0,next_router.useRouter)();
    var isOverVersion = (0,misc/* checkRequiredAppVersion */._h)(platform, version, constants/* SUBSCIRBE_VERSION */.Ww);
    var ref18 = _slicedToArray((0,useModal/* useModal */.d)("fan-club-modal"), 2), isFanClubModalOpen = ref18[0], ref19 = ref18[1], openFanClubModal = ref19.open, closeFanClubModal = ref19.close;
    var handleModifyProfile = function() {
        if (isMyPage && platform !== constants/* Platform.web */.t4.web) {
            web.openPage("/me/profile");
        } else {
            router.push("/me/profile");
        }
    };
    var handleGoToFanPage = function() {
        if (!(user === null || user === void 0 ? void 0 : user.isFan) && (me === null || me === void 0 ? void 0 : me.id) !== (user === null || user === void 0 ? void 0 : user.id)) {
            openFanClubModal();
            return;
        }
        if (isMyPage) {
            if (platform == constants/* Platform.web */.t4.web) {
                router.push("/me/fan-club");
            } else {
                web.openPage("/me/fan-club");
            }
        } else {
            if (platform == constants/* Platform.web */.t4.web) {
                router.push("/users/".concat(userId, "/fan-club"));
            } else {
                web.openPage("/users/".concat(userId, "/fan-club"));
            }
        }
    };
    var handleGoToFollowerPage = function() {
        if (!(user === null || user === void 0 ? void 0 : user.isFan) && (me === null || me === void 0 ? void 0 : me.id) !== (user === null || user === void 0 ? void 0 : user.id)) {
            openFanClubModal();
            return;
        }
        if (isMyPage && platform !== constants/* Platform.web */.t4.web) {
            web.openPage("/users/".concat(userId, "/followers"));
        } else {
            router.push("/users/".concat(userId, "/followers"));
        }
    };
    var handleGoToFollowingPage = function() {
        if (isMyPage && platform !== constants/* Platform.web */.t4.web) {
            web.openPage("/users/".concat(userId, "/followings"));
        } else {
            router.push("/users/".concat(userId, "/followings"));
        }
    };
    var handleToggleFollow = (0,react.useCallback)(function() {
        if (!user) {
            return;
        }
        toggleFollow(user.id, {
            onSuccess: function() {
                optimistic.update(constants/* QUERY_KEYS.USER.ONE */.U7.USER.ONE(userId), function(user) {
                    return UserInfo_objectSpreadProps(UserInfo_objectSpread({}, user), {
                        isFollowing: !user.isFollowing
                    });
                });
            }
        });
    }, [
        user === null || user === void 0 ? void 0 : user.id
    ]);
    var handleClickPayment = function(e) {
        e.stopPropagation();
        e.preventDefault();
        if (platform === constants/* Platform.web */.t4.web) {
            return router.push("/payment");
        }
        if ((0,misc/* checkRequiredAppVersion */._h)(platform, version, {
            iOS: "2.26.1",
            android: "2.32.4"
        })) {
            return web.openPage("/payment");
        } else {
            return (0,misc/* openDeepLink */.Hu)("chatie-app://payment", router);
        }
    };
    var handleClickSubscription = function() {
        if (isPending) {
            openSubsErrorModal();
            return;
        }
        if (platform === constants/* Platform.web */.t4.web) {
            return router.push("/me/subscriptions");
        }
        web.openPage("/me/subscriptions");
    };
    if (!user) {
        return null;
    }
    var backgroundDecoration = (ref9 = getDecoration(data, constants/* MarketItemType.profileBg */.q9.profileBg)) === null || ref9 === void 0 ? void 0 : ref9.object.pageProfile;
    var profileBtnDecoration = getDecoration(data, constants/* MarketItemType.profileBtn */.q9.profileBtn);
    var ref20, ref21;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("main", {
            css: userInfoWrapCSS(!!backgroundDecoration),
            children: [
                backgroundDecoration && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("section", {
                    css: userBackgroundCSS,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: backgroundDecoration,
                        objectPosition: "center top"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: userCSS,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "avatarContainer",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Avatar/* default */.ZP, UserInfo_objectSpread({
                                    css: userAvatarCSS,
                                    size: Avatar/* AvatarSize.xlarge */.DZ.xlarge
                                }, user)),
                                userId === (me === null || me === void 0 ? void 0 : me.id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "modifyBtn",
                                    onClick: handleModifyProfile,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* Pencil */.z,
                                        size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                        color: theme.var.white
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Nickname/* default */.Z, UserInfo_objectSpreadProps(UserInfo_objectSpread({}, user), {
                                size: dist_esm/* Sizes.small */.u8.small
                            }))
                        }),
                        user.ban ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: userBanCSS,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                    children: t("정지 기간")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    children: (0,date/* isAfter */.Ax)(user.ban.ended, "2070-01-01T00:00:00") ? t("영구정지") : "".concat((0,date/* formatDate */.p6)(user.ban.started), " ~ ").concat((0,date/* formatDate */.p6)(user.ban.ended))
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                    children: t("정지 사유")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    children: user.ban.reason
                                })
                            ]
                        }) : user.introduce ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: "multiline",
                            children: user.introduce
                        }) : null,
                        balloon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: balloonContainerCSS,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    className: "info",
                                    children: [
                                        !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                            icon: ic_free_balloon
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                            children: [
                                                t("보유 ".concat(goodsName, " ")),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                    className: "highlight weight",
                                                    children: t("".concat((0,misc/* formatComma */.cO)((ref20 = me === null || me === void 0 ? void 0 : me.balloon) !== null && ref20 !== void 0 ? ref20 : 0)))
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                    className: "highlight",
                                                    children: t("개")
                                                })
                                            ]
                                        }),
                                        isMyPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                    className: "slash",
                                                    children: t("/")
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                                    children: [
                                                        t("대화권 "),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                            className: "highlight weight",
                                                            children: t("".concat((0,misc/* formatComma */.cO)((ref21 = me === null || me === void 0 ? void 0 : (ref10 = me.chatToken) === null || ref10 === void 0 ? void 0 : ref10.tokenCount) !== null && ref21 !== void 0 ? ref21 : 0)))
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                            className: "highlight",
                                                            children: t("개")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    className: "arrow-container",
                                    onClick: handleClickPayment,
                                    children: [
                                        t("충전하기"),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                            icon: icon/* ArrowRight */.ol,
                                            size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                            color: theme.var.gray500
                                        })
                                    ]
                                })
                            ]
                        }),
                        subscription && isOverVersion && !!subscriptionState && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: subscriptionCSS,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "container",
                                onClick: handleClickSubscription,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("path", {
                                                    d: "M8 7.83334V8.16668M8 5.33334V5.66668M8 10.3333V10.6667M12.6667 12.6667C13.0203 12.6667 13.3594 12.5262 13.6095 12.2762C13.8595 12.0261 14 11.687 14 11.3333V9.33334C13.6464 9.33334 13.3072 9.19287 13.0572 8.94282C12.8071 8.69277 12.6667 8.35363 12.6667 8.00001C12.6667 7.64639 12.8071 7.30725 13.0572 7.0572C13.3072 6.80715 13.6464 6.66668 14 6.66668V4.66668C14 4.31305 13.8595 3.97392 13.6095 3.72387C13.3594 3.47382 13.0203 3.33334 12.6667 3.33334H3.33333C2.97971 3.33334 2.64057 3.47382 2.39052 3.72387C2.14048 3.97392 2 4.31305 2 4.66668V6.66668C2.35362 6.66668 2.69276 6.80715 2.94281 7.0572C3.19286 7.30725 3.33333 7.64639 3.33333 8.00001C3.33333 8.35363 3.19286 8.69277 2.94281 8.94282C2.69276 9.19287 2.35362 9.33334 2 9.33334V11.3333C2 11.687 2.14048 12.0261 2.39052 12.2762C2.64057 12.5262 2.97971 12.6667 3.33333 12.6667H12.6667Z",
                                                    stroke: "currentColor",
                                                    "stroke-width": "1.25",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                })
                                            }),
                                            t(isExpired ? "지금 다시 구독하고 할인을 놓치지 마세요!" : isPending ? "문제가 생겼어요. 여기를 클릭해 내용을 확인해 주세요." : "나의 구독"),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                className: "highlight ".concat(isInHold ? "red" : ""),
                                                children: t(isInProgress ? "플레이 박스 정기 구독중" : isInHold ? "결제 실패 상태에요" : "")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        className: "arrow-container",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                            icon: icon/* ArrowRight */.ol,
                                            size: dist_esm/* Sizes.xsmall */.u8.xsmall,
                                            color: theme.var.gray500
                                        })
                                    })
                                ]
                            })
                        }),
                        !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: userNumericInfoCSS,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("dl", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dt", {
                                            children: t("simplifyNumber", {
                                                val: user.storyTapCount
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dd", {
                                            children: t("탭")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("dl", {
                                    onClick: handleGoToFanPage,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dt", {
                                            children: t("simplifyNumber", {
                                                val: user.fanCount
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dd", {
                                            children: t("팬")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("dl", {
                                    onClick: handleGoToFollowerPage,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dt", {
                                            children: t("simplifyNumber", {
                                                val: user.followerCount
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dd", {
                                            children: t("팔로워")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("dl", {
                                    onClick: handleGoToFollowingPage,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dt", {
                                            children: t("simplifyNumber", {
                                                val: user.followingCount
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("dd", {
                                            children: t("팔로잉")
                                        })
                                    ]
                                })
                            ]
                        }),
                        userId !== (me === null || me === void 0 ? void 0 : me.id) && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: userButtonWrapCSS,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* DecoratedButton */.b, {
                                css: userButtonCSS,
                                decoration: profileBtnDecoration,
                                onClick: handleToggleFollow,
                                children: user.isFollowing ? t("팔로우 중") : t("팔로우")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_FanClubModal, {
                    open: isFanClubModalOpen,
                    onClose: closeFanClubModal
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_SubscriptionErrorModal, {
                    open: isSubsErrorModalOpen,
                    onClose: closeSubsErrorModal,
                    name: "subs-error-modal"
                })
            ]
        })
    });
};
/* harmony default export */ var user_UserInfo = (UserInfo);


/***/ }),

/***/ 75046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ usePlayerStats; },
/* harmony export */   "n": function() { return /* binding */ usePlayer; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72218);
/* harmony import */ var _api_chatbot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23082);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var usePlayer = function(id, options) {
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.PLAYER */ .U7.PLAYER(id), function() {
        return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .fetchPlayer */ .I_)(id);
    }, _objectSpread({
        enabled: !!id,
        staleTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60),
        cacheTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60)
    }, options));
    return query;
};
var usePlayerStats = function(options) {
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.MY_STATS */ .U7.MY_STATS, function() {
        return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyPlayerStats */ .zJ)();
    }, _objectSpread({
        staleTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60),
        cacheTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60)
    }, options));
    return query;
};


/***/ }),

/***/ 41785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ BROADCAST_CHANNEL; },
/* harmony export */   "t": function() { return /* binding */ useBroadcastChannel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var broadcast_channel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38718);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64912);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(semver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30259);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45874);






var BROADCAST_CHANNEL = {
    CHARACTER_UPDATE: "character_update",
    CHARACTER_DELETE: "character_delete",
    VERIFICATION_EVENT_CONFIRM: "verification_event_confirm",
    PURCHASE_DAILY_FREE_PASS: "purchase_daily_free_pass"
};
function useBroadcastChannel(channelName, onMessage, options) {
    var ref = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalContext */ .bN)(), platform = ref.platform, os = ref.os;
    var isUnderVersion = platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && os && !semver__WEBPACK_IMPORTED_MODULE_1___default().gte((0,_utils_misc__WEBPACK_IMPORTED_MODULE_4__/* .normalizeVersion */ .Kt)(os), "15.4.0");
    var broadcastChannelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onMessageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage(message);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (onMessage) {
            onMessageRef.current = onMessage;
        }
    }, [
        onMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        var mounted = true;
        var channel = new broadcast_channel__WEBPACK_IMPORTED_MODULE_5__/* .BroadcastChannel */ .g0(channelName, options);
        var handleMessage = function(message) {
            var ref;
            if (!mounted) {
                return;
            }
            (ref = onMessageRef.current) === null || ref === void 0 ? void 0 : ref.call(onMessageRef, message);
        };
        channel.onmessage = handleMessage;
        broadcastChannelRef.current = channel;
        return function() {
            mounted = false;
            broadcastChannelRef.current = null;
            channel.close();
        };
    }, [
        channelName,
        options
    ]);
    return {
        postChannelMessage: handlePostMessage
    };
}


/***/ }),

/***/ 37666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ useFirebase; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
;// CONCATENATED MODULE: ./utils/namespace.ts

var getCurationNamespace = function(router) {
    var title = router.query.title;
    var subSections = [];
    try {
        subSections = JSON.parse(router.query.sub_sections) || [];
    } catch (error) {
        subSections = [];
    }
    var subSectionIndex = 0;
    try {
        subSectionIndex = parseInt(router.query.sub_section_index) || 0;
    } catch (err) {
        subSectionIndex = 0;
    }
    var sectionId = 0;
    try {
        sectionId = subSections.length ? subSections[subSectionIndex].id : parseInt(router.query.sectionId);
    } catch (err1) {
        sectionId = 0;
    }
    var _section_type;
    var sectionType = (_section_type = router.query.section_type) !== null && _section_type !== void 0 ? _section_type : constants/* SectionType.original */.bA.original;
    if (subSections === null || subSections === void 0 ? void 0 : subSections.length) {
        var subSection = subSections === null || subSections === void 0 ? void 0 : subSections.find(function(s) {
            return s.id === sectionId;
        });
        if (subSection) {
            var id = subSection.id, name = subSection.name;
            var subPath = "".concat(name, "(").concat(id, ")").replace("/", "+");
            return sectionType === constants/* SectionType.standard */.bA.standard ? "홈/스탠다드/".concat(title, "/더보기/").concat(subPath) : "홈/오리지널/".concat(title, "/더보기/").concat(subPath);
        }
    }
    return sectionType === constants/* SectionType.standard */.bA.standard ? "홈/스탠다드/".concat(title, "/더보기") : "홈/오리지널/".concat(title, "/더보기");
};
var getSearchResultNamespace = function(router) {
    var tab = router.query.tab;
    switch(tab){
        case "story":
            return "검색결과/작품";
        case "user":
            return "검색결과/작가";
        case "tag":
            return "검색결과/태그";
        default:
            return "검색결과";
    }
};
var getSearchNamespace = function(router) {
    var tab = router.query.tab || "recommend";
    if (tab === "recommend") {
        return "검색/AI추천";
    }
    return "검색/카테고리(".concat(tab, ")");
};
var getLibraryNamespace = function(router) {
    var tab = router.query.tab || "read-stories";
    switch(tab){
        case "following-feed":
            return "내서재/팔로잉";
        case "liked-stories":
            return "내서재/좋아요";
        case "chat-library":
            return "내서재/플레이";
        default:
            return "내서재/읽은작품";
    }
};
var getPlayNamespace = function() {
    return "플레이/캐릭터 상세";
};
var getUsersNamespace = function() {
    return "작가상세/작품";
};
var getStoryListByTagsNamespace = function(router) {
    var tab = router.query.tab || "popular";
    return tab === "popular" ? "작품상세/태그상세/인기작품" : "작품상세/태그상세/최신작품";
};
var getPageNamespace = function(router) {
    var currentPath = router.asPath;
    var pathCheckers = [
        {
            regex: /\/curations\/\d+/,
            getNamespace: getCurationNamespace
        },
        {
            regex: /\/search\/(.+)/,
            getNamespace: getSearchResultNamespace
        },
        {
            regex: /\/search/,
            getNamespace: getSearchNamespace
        },
        {
            regex: /\/library/,
            getNamespace: getLibraryNamespace
        },
        {
            regex: /\/play\/characters\/\d+/,
            getNamespace: getPlayNamespace
        },
        {
            regex: /\/users\/\d+/,
            getNamespace: getUsersNamespace
        },
        {
            regex: /\/tags\/\d+\/stories/,
            getNamespace: getStoryListByTagsNamespace
        }, 
    ];
    var matchedPath = pathCheckers.find(function(pathChecker) {
        return currentPath.match(pathChecker.regex);
    });
    var ref;
    return (ref = matchedPath === null || matchedPath === void 0 ? void 0 : matchedPath.getNamespace(router)) !== null && ref !== void 0 ? ref : "기타페이지";
};

;// CONCATENATED MODULE: ./hooks/useFirebase.ts





var useFirebase = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,hook/* useMe */.Pi)(), user = ref.data;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var inflow = (0,react.useCallback)(function(id, options) {
        if (!user) {
            return;
        }
        var ref;
        firebase.logEvent("story_inflow", {
            storyId: id,
            userId: user.id,
            userCreated: user.created,
            path: (ref = options === null || options === void 0 ? void 0 : options.path) !== null && ref !== void 0 ? ref : getPageNamespace(router)
        });
    }, [
        router,
        user
    ]);
    return {
        inflow: inflow
    };
};


/***/ }),

/***/ 70182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useLoadingStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88766);

var useLoadingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        isLoading: false,
        setLoading: function(isLoading) {
            set({
                isLoading: isLoading
            });
        }
    };
});


/***/ }),

/***/ 83472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useReadStoryStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88766);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useReadStoryStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set, get) {
    return {
        data: undefined,
        selectedIds: [],
        readStoryIds: [],
        read: function(episode) {
            var data = get().data;
            if (!data) {
                set({
                    data: {
                        storyId: episode.story.id,
                        episodeId: episode.id,
                        readEpisodeCount: 1,
                        tapCount: 0,
                        startReadDatetime: new Date().toISOString(),
                        endReadDatetime: new Date().toISOString(),
                        isLastEpisodeRead: !episode.nextEpisode,
                        ageGrade: episode.story.ageGrade
                    }
                });
            } else {
                set({
                    data: _objectSpreadProps(_objectSpread({}, data), {
                        episodeId: episode.id,
                        readEpisodeCount: data.readEpisodeCount + 1,
                        endReadDatetime: new Date().toISOString(),
                        isLastEpisodeRead: !episode.nextEpisode,
                        ageGrade: episode.story.ageGrade
                    })
                });
            }
        },
        tap: function() {
            var data = get().data;
            if (!data) {
                return;
            }
            set({
                data: _objectSpreadProps(_objectSpread({}, data), {
                    tapCount: data.tapCount + 1
                })
            });
        },
        tick: function() {
            var data = get().data;
            if (!data) {
                return;
            }
            set({
                data: _objectSpreadProps(_objectSpread({}, data), {
                    endReadDatetime: new Date().toISOString()
                })
            });
        },
        reset: function() {
            set({
                data: undefined
            });
        },
        select: function(id) {
            var selectedIds = get().selectedIds;
            set({
                selectedIds: _toConsumableArray(selectedIds).concat([
                    id
                ])
            });
        },
        cancelSelect: function(id) {
            var selectedIds = get().selectedIds;
            var updatedSelectedIds = selectedIds.filter(function(itemId) {
                return itemId !== id;
            });
            set({
                selectedIds: updatedSelectedIds
            });
        },
        deselectAll: function() {
            set({
                selectedIds: []
            });
        },
        selectAll: function() {
            var readStoryIds = get().readStoryIds;
            set({
                selectedIds: readStoryIds
            });
        },
        setReadStoryIds: function(readStoryPages) {
            var readStoryIds = readStoryPages.flatMap(function(page) {
                return page.items.map(function(item) {
                    return item.id;
                });
            });
            set({
                readStoryIds: readStoryIds
            });
        }
    };
});


/***/ }),

/***/ 42079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgProfile32 = function SvgProfile32(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.077 11.692a4.923 4.923 0 1 0 9.846 0 4.923 4.923 0 0 0-9.846 0m8.26 7.385c2.576 0 4.663 2.755 4.663 6.154H8c0-3.4 2.087-6.154 4.663-6.154h6.674",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgProfile32);

/***/ })

}]);